/**
 * AIF-03 — shared display constants for the import wizard.
 */
import type { AiFindingsDeletionScope } from "@aeriosiq/types";

/** Human-readable label for a SCREAMING_SNAKE state. */
export function formatState(state: string): string {
  const lower = state.toLowerCase().replace(/_/g, " ");
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export interface DeletionScopeOption {
  value: AiFindingsDeletionScope;
  label: string;
  hint: string;
}

/** The 4 deletion-scope radio options (story §"Deletion scope"). */
export const DELETION_SCOPE_OPTIONS: readonly DeletionScopeOption[] = [
  {
    value: "ALL",
    label: "All findings for this DA",
    hint: "Soft-delete every live finding on the data acquisition (any model/version).",
  },
  {
    value: "SAME_MODEL",
    label: "Same model",
    hint: "Soft-delete live findings of the chosen model (any version).",
  },
  {
    value: "SAME_MODEL_VERSION",
    label: "Same model + version",
    hint: "Soft-delete live findings of the chosen model and version only.",
  },
  {
    value: "ADDITIVE",
    label: "Additive (keep all)",
    hint: "Delete nothing — keep every existing finding.",
  },
] as const;
